import angular from 'angular';
import moment from 'moment';
import dateFormatService from '../../../shared/services/DateFormatService';

const inputRegex = /^\s*(\d?\d)\s*(\/|-)\s*(\d?\d)\s*$/;

angular.module('cloudX').directive('dayMonthConverter', function() {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function(scope, el, attrs, ngModel) {
      if (!ngModel) return;
      let outputType = attrs.dayMonthConverter || 'string';
      if (outputType === 'day-month-converter') outputType = 'string';

      ngModel.$formatters.push(function(value) {
        if (value === null) return null;
        if (typeof value === 'undefined') return undefined;

        let dateValue;
        if (typeof value === 'string') {
          dateValue = moment.utc(value.substr(0, 10));
        } else if (value instanceof Date) {
          dateValue = moment(value).utc();
        } else if (moment.isMoment(value)) {
          dateValue = moment(value).utc();
        } else {
          //Unknown type
          return value;
        }

        return dateFormatService.formatDayMonth(dateValue.toISOString());
      });

      ngModel.$parsers.push(function(value) {
        if (!value) return null;
        const match = value.match(inputRegex);
        if (match) {
          const dateValue = moment.utc(`2000-${match[3]}-${match[1]}`, 'YYYY-MM-DD');
          if (dateValue.isValid()) {
            ngModel.$setValidity('date', true);
            if (outputType === 'string') return dateValue.format('YYYY-MM-DD');
            if (outputType === 'moment') return dateValue;
            if (outputType === 'date') return dateValue.local().toDate();
            if (outputType === 'dateUTC') return dateValue.toDate();
            return dateValue.format('YYYY-MM-DD');
          }
        }
        ngModel.$setValidity('date', false);
        return undefined;
      });
    },
  };
});
